import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-height: 100dvh;
`;
